import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ProductItem from '../ProductItem';
import { useQuery } from '@apollo/client';
import { QUERY_CATEGORY, QUERY_PRODUCTS } from '../../utils/queries';
import spinner from '../../assets/spinner.gif';

function ProductList() {
  const { category_slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);

  const { loading, data } =
    useQuery(QUERY_PRODUCTS, {variables: {category_slug}});

  const { data: categoryData } =
    useQuery(QUERY_CATEGORY, {variables: {slug: category_slug}});

  useEffect(() => {
    if (data) {
      setProducts(data.productsInCategory);
    }
    if (categoryData) {
      setCategory(categoryData.category);
    }
  }, [data, categoryData ]);

  return (
    <div className="my-2">
      <h2>{`Our ${category ? category.name : ''} Products`}</h2>
      {products.length ? (
        <div className="flex-row">
          {products.map((product) => (
            <ProductItem
              key={product._id}
              product={product}
            />
          ))}
        </div>
      ) : (
        <h3>We are building the catalog right now. Please check back soon.</h3>
      )}
      {loading ? <img src={spinner} alt="loading" /> : null}
    </div>
  );
}

export default ProductList;
